import React from 'react';
import PropTypes from 'prop-types';
// import classnames from 'classnames';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { getPriceExtensionStyles } from '../styles';

const PriceExtension = ({
  classes,
  extensionData,
}) => (
  <div className={classes.priceExtensionContainer}>
    {
      extensionData.map(({
        Header, Description, Currency, Price, FinalUrls,
      }, index) => (
        <React.Fragment>
          <a href={FinalUrls[0]}>{Header}</a>
          <span>{` - ${Description} `}</span>
          <div>{`${Currency + Price}`}</div>
          {index < extensionData.length - 1 && <span>{' · '}</span>}
        </React.Fragment>
      ))
    }
  </div>
);

PriceExtension.propTypes = {
  classes: PropTypes.shape({
    priceExtensionContainer: PropTypes.string,
  }),
  extensionData: PropTypes.arrayOf(PropTypes.shape({
    Header: PropTypes.string,
    Description: PropTypes.string,
    Currency: PropTypes.string,
    Price: PropTypes.string,
    FinalUrls: PropTypes.arrayOf(PropTypes.string),
  })),
};

PriceExtension.defaultProps = {
  classes: {},
  extensionData: [],
};

export const AdPreviewPriceExtension = withUAPLThemedStyles(
  PriceExtension,
  getPriceExtensionStyles, { componentName: 'AdPreviewPriceExtension' }
);
